<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{ $ml.get('shared.users') }}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{ $ml.get('shared.dashboard') }}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{ $ml.get('shared.settings') }}</span>
        </li>
        <li>
          <span>{{ $ml.get('shared.users') }}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-3">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{ $ml.get('users.users') }}</span>
              </h3>
              <div class="box-tools pull-right">
                <button v-show="authControl == 0" type="button" class="btn btn-sm btn-warning"
                  @click="newUser()">{{ $ml.get('users.newUser') }}</button>
              </div>
            </div>
            <div class="box-body">
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText" class="form-control"
                style="margin-bottom:10px;" autocomplete="false" />
              <div v-show="userList.length > 0" class="table-responsive no-padding" :style="windowHeightSize">
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="user in userList" :key="user.id">
                      <td>
                        {{ user.name }}
                        <span v-show="user.title != ''">({{ user.title }})</span>
                      </td>
                      <td class="pull-right">
                        <button type="button" class="btn btn-primary btn-sm" @click="getUser(user.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="userList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{ $ml.get('users.userNotRecord') }}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-9">
          <div class="row">
            <div class="col-sm-4">
              <div class="box box-primary">
                <div class="box-header">
                  <h3 class="box-title">
                    <span>{{ $ml.get('users.userPhoto') }}</span>
                  </h3>
                </div>
                <div class="box-body box-profile" align="center">
                  <img
                    :src="(this.user.photo == null && this.tempUrl == null) || (this.user.photo == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.user.photo || this.tempUrl"
                    class="profile-user-img img-responsive img-circle" style="height: 150px; width: 150px;" />
                  <a href="#" v-show="this.tempUrl || this.user.photo" @click="removeImage()" class="text-red">
                    <i class="fa fa-remove"></i>
                    {{ $ml.get('general.remove') }}
                  </a>
                  <hr />
                  <my-upload field="img" @crop-success="cropSuccess" langType="tr" v-model="showImageDialog" :width="200"
                    :height="200" url="/images" :params="params" :headers="headers" img-format="png"></my-upload>
                  <button type="button" @click="toggleShow()" class="btn btn-primary btn-sm" style="width:100%">
                    <i class="fa fa-upload"></i>
                    {{ $ml.get('users.selectPhoto') }}
                  </button>
                </div>
                <div class="overlay" id="load" :hidden="!isLoadingDetail">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
              <button :class="filters.nameOrCardNumber != '' ? 'btn btn-success' : 'btn btn-warning'" data-toggle="modal"
                data-target="#modal-filtre" style="width:100%;margin-bottom:10px;">
                <i class="fa fa-filter"></i> Varsayılan Filtre Grubu
              </button>
              <div class="box box-primary">
                <div class="box-header">
                  <h3 class="box-title">{{ $ml.get('users.companyAuthorities') }}</h3>
                </div>
                <div class="box-body">
                  <div v-show="companyList.length > 0" class="table-responsive no-padding"
                    style="max-height:200px; owerflow:auto;">
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="company in companyList" :key="company.id">
                          <td>
                            <div class="checkbox" style="margin-left:20px;">
                              <label>
                                <input type="checkbox" :checked="company.check"
                                  @change="company.check == true ? company.check = false : company.check = true" />
                                {{ company.name }}
                              </label>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="companyList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{ $ml.get('users.companyNotRecord') }}
                  </div>
                </div>
                <div class="overlay" id="load" :hidden="!isLoadingCompanies">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-8">
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title">
                    <span>{{ $ml.get('users.userInformation') }}</span>
                  </h3>
                  <div class="box-tools pull-right"></div>
                </div>
                <div class="box-body">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>{{ $ml.get('users.userName') }}</label>
                        <input v-model="user.name" type="text" class="form-control" placeholder />
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.userTitle') }}</label>
                        <input v-model="user.title" type="text" class="form-control" placeholder />
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.email') }}</label>
                        <input v-model="user.mail" type="text" class="form-control" placeholder />
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.authorityGroup') }}</label>
                        <select @change="changeUserAuthGroup($event)" class="form-control">
                          <option selected="selected" value="0">{{ $ml.get('general.select') }}</option>
                          <option v-for="userAuthGroup in userAuhtGroupList" :value="userAuthGroup.id"
                            :selected="userAuthGroup.id == user.authId" :key="userAuthGroup.id">{{ userAuthGroup.name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.password') }}</label>
                        <input v-model="user.password" type="password" class="form-control" placeholder />
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.repeatPassword') }}</label>
                        <input v-model="user.password2" type="password" class="form-control" placeholder />
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.phoneNumber') }}</label>
                        <input v-model="user.phoneNumber" type="text" class="form-control" placeholder />
                      </div>
                      <div class="form-group" v-show="modules.smsOrMail">
                        <label>{{ $ml.get('users.activateSmsSystem') }}</label>
                        <span class="form-control checkbox">
                          <label style="margin-left:20px;">
                            <input :checked="user.isSmsSend"
                              @change="user.isSmsSend == true ? user.isSmsSend = false : user.isSmsSend = true"
                              type="checkbox" />
                            {{ $ml.get('users.activateSmsSystem') }}
                          </label>
                        </span>
                      </div>
                      <div class="form-group">
                        <label>{{ $ml.get('users.realTimeMonitorGroup') }}</label>
                        <div class="input-group">
                          <select @change="changeMonitorGroup($event)" class="form-control">
                            <option selected="selected" value="0">{{ $ml.get('general.select') }}</option>
                            <option v-for="monitorGroup in monitorGroupList" :value="monitorGroup.id"
                              :selected="monitorGroup.id == user.monitorGroupId" :key="monitorGroup.id">
                              {{ monitorGroup.name }}</option>
                          </select>
                          <div class="input-group-btn">
                            <button class="btn btn-primary" data-toggle="modal" data-target="#modal-real-time-group">
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="form-group" v-show="modules.visitor">
                        <label>{{ $ml.get('users.visitorCardGroup') }}</label>
                        <select @change="changeVisitorGroup($event)" class="form-control">
                          <option selected="selected" value="0">{{ $ml.get('general.select') }}</option>
                          <option v-for="visitorGroup in visitorGroupList" :value="visitorGroup.id"
                            :selected="visitorGroup.id == user.visitorCardGroup" :key="visitorGroup.id">
                            {{ visitorGroup.name }}</option>
                        </select>
                      </div>
                      <div class="form-group" style="margin-bottom:5px;">
                        <label>{{ $ml.get('general.isActive') }}</label>
                        <span class="form-control checkbox">
                          <label style="margin-left:20px;">
                            <input :checked="user.isActive"
                              @change="user.isActive == true ? user.isActive = false : user.isActive = true" type="checkbox" />
                            {{ $ml.get('general.active') }}
                          </label>
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <h4>
                        {{ $ml.get('users.reportAuthorities') }}
                        <a style="text-align:right;"
                          @click="isCheckReports == true ? getCheckReportAll(false) : getCheckReportAll(true)">
                          <span style="font-size:15px;"
                            v-text="isCheckReports == true ? this.$ml.get('general.removeAll') : this.$ml.get('general.selectAll')"></span>
                        </a>
                      </h4>
                      <div v-show="reportList.length > 0" class="table-responsive no-padding"
                        :style="windowReportHeightSize">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="report in reportList" :key="report.id">
                              <td>
                                <div class="checkbox" style="margin-left:20px;">
                                  <label>
                                    <input type="checkbox" :checked="report.isActive"
                                      @change="report.isActive == true ? report.isActive = false : report.isActive = true" />
                                    {{ report.name }}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="reportList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('users.reportNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overlay" :hidden="!isLoadingDetail">
                  <i class="fa fa-refresh fa-spin"></i>
                </div>
                <div class="box-footer">
                  <div class="pull-right">
                    <button v-show="!isNewUser && authControl == 0" type="button" data-toggle="modal"
                      data-target="#modal-sil" class="btn btn-sm btn-danger"
                      style="margin: 5px; width:120px;">{{ $ml.get('general.delete') }}</button>
                    <button v-show="isNewUser && authControl == 0" type="button" data-toggle="modal"
                      data-target="#modal-kaydet" class="btn btn-sm btn-success"
                      style="margin: 5px; width:120px;">{{ $ml.get('general.save') }}</button>
                    <button v-show="!isNewUser && authControl == 0" type="button" data-toggle="modal"
                      data-target="#modal-guncelle" class="btn btn-sm btn-success"
                      style="margin: 5px; width:120px;">{{ $ml.get('general.update') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.update') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.user.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('users.isContinueUserUpdate') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveUser()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.save') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{ this.user.name }}</p>
              <span>{{ $ml.get('users.isContinueUserSave') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click="saveUser()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{ $ml.get('general.save') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('general.delete') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{ this.user.name }}</span>
              </div>
              <br />
              <p></p>
              <span>{{ $ml.get('users.isContinueUserDelete') }}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{ $ml.get('general.cancel') }}</span>
              </button>
              <button @click.prevent="deleteUser()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--CANLI İZLEME GRUBU MODAL -->
      <div class="modal modal-primary fade" id="modal-real-time-group" style="display: none;">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('users.realTimeMonitorGroups') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-5">
                  <div class="box box-primary">
                    <div class="box-header">
                      <h4 class="box-title">{{ $ml.get('users.realTimeMonitorGroupList') }}</h4>
                      <div class="pull-right box-tools">
                        <button @click="newRealTimeMonitor()"
                          class="btn btn-sm btn-warning">{{ $ml.get('users.newRealTimeMonitorGroup') }}</button>
                      </div>
                    </div>
                    <div class="box-body">
                      <div v-show="monitorGroupList.length > 0" class="table-responsive no-padding"
                        :style="windowHeightTableSize">
                        <table class="table table-hover">
                          <tbody>
                            <tr v-for="monitorGroup in monitorGroupList" :key="monitorGroup.id">
                              <td>{{ monitorGroup.name }}</td>
                              <td>
                                <button
                                  @click="selectRealTimeMonitor(monitorGroup.id, monitorGroup.name, monitorGroup.devices)"
                                  class="btn btn-sm btn-primary">
                                  <i class="fa fa-search"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-show="monitorGroupList.length == 0" class="callout callout-info">
                        <i class="fa fa-info-circle"></i>
                        {{ $ml.get('users.realTimeMonitorGroupNotRecord') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-7">
                  <div class="form-group">
                    <label>{{ $ml.get('users.groupName') }}</label>
                    <input v-model="selectedRealTimeMonitorName" type="text" class="form-control" />
                  </div>
                  <div v-show="activeReaderList.length > 0" class="table-responsive no-padding"
                    :style="windowHeightTableSize">
                    <table class="table table-hover" style="background-color:white;">
                      <tbody>
                        <tr v-for="reader in activeReaderList" :key="reader.id">
                          <td class="checkbox">
                            <label style="margin-left:20px;color:black;">
                              <input type="checkbox" name="check" :checked="reader.check"
                                @change="reader.check == true ? reader.check = false : reader.check = true" />
                              {{ reader.ipAddress }} | {{ reader.readerNo }} - {{ reader.name }}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="activeReaderList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{ $ml.get('users.deviceNotRecord') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline pull-left"
                data-dismiss="modal">{{ $ml.get('general.cancel') }}</button>
              <button v-show="!isNewRealTimeMonitor" type="button" @click="deleteRealTimeMonitor()"
                class="btn btn-outline btn-danger">
                <span>{{ $ml.get('general.delete') }}</span>
              </button>
              <button type="button" @click="saveRealTimeMonitor()" class="btn btn-outline btn-success">
                <span v-show="isNewRealTimeMonitor">{{ $ml.get('general.save') }}</span>
                <span v-show="!isNewRealTimeMonitor">{{ $ml.get('general.update') }}</span>
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--CANLI İZLEME GRUBU MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-primary fade" id="modal-filtre">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterEmployees') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterNameSurnameOrCardNo') }}</span>
                    <input v-model="filters.nameOrCardNumber" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterNameSurnameOrCardNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterCitizenshipNumber') }}</span>
                    <input v-model="filters.identityNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterCitizenshipNumber')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterRegistrationOrDeviceNo') }}</span>
                    <input v-model="filters.sicilOrTerminalNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterRegistrationOrDeviceNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterDocumentNoOrEmail') }}</span>
                    <input v-model="filters.documentNoOrMail" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterDocumentNoOrEmail')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group" v-show="modules.licencePlateRecognition">
                    <span>{{ $ml.get('filters.filterPlateNo') }}</span>
                    <input v-model="filters.plateNo" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterPlateNo')" style="margin-bottom:5px;" />
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterStatus') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStatusList != ''" class="form-control tdb-box">{{ checkedStatusList }}</label>
                      <label v-show="checkedStatusList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-status">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStatusList != ''" class="btn btn-danger" @click="clearFilterStatus()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterState') }}</label>
                    <div class="input-group">
                      <label v-show="checkedStateList != ''" class="form-control tdb-box">{{ checkedStateList }}</label>
                      <label v-show="checkedStateList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-state">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedStateList != ''" class="btn btn-danger" @click="clearFilterStates()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <span>{{ $ml.get('filters.filterTitle') }}</span>
                    <select @change="changeFilterTitles($event)" class="form-control input-sm" style="margin-bottom:5px;">
                      <option :selected="filters.title == ''" value>{{ $ml.get('general.select') }}</option>
                      <option v-for="title in titleList" :key="title.name" :value="title.name"
                        :selected="title.name == filters.title">{{ title.name }}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterDepartments') }}</label>
                    <div class="input-group">
                      <label v-show="checkedDepartmentList != ''"
                        class="form-control tdb-box">{{ checkedDepartmentList }}</label>
                      <label v-show="checkedDepartmentList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-department">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedDepartmentList != ''" class="btn btn-danger"
                          @click="clearFilterDepartments()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterAccessGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedAccessGroupList != ''"
                        class="form-control tdb-box">{{ checkedAccessGroupList }}</label>
                      <label v-show="checkedAccessGroupList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-access">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedAccessGroupList != ''" class="btn btn-danger"
                          @click="clearFilterAccessGroup()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{ $ml.get('filters.filterWorkPlan') }}</label>
                    <div class="input-group">
                      <label v-show="checkedWorkGroupList != ''"
                        class="form-control tdb-box">{{ checkedWorkGroupList }}</label>
                      <label v-show="checkedWorkGroupList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-workplan">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedWorkGroupList != ''" class="btn btn-danger"
                          @click="clearFilterWorkPlans()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-show="modules.diningHall">
                    <label>{{ $ml.get('filters.filterFoodGroup') }}</label>
                    <div class="input-group">
                      <label v-show="checkedFoodGroupList != ''"
                        class="form-control tdb-box">{{ checkedFoodGroupList }}</label>
                      <label v-show="checkedFoodGroupList == ''"
                        class="form-control">{{ $ml.get('general.notSelected') }}</label>
                      <div class="input-group-btn">
                        <button class="btn btn-default" data-toggle="modal" data-target="#modal-select-diningHall">
                          <i class="fa fa-search"></i>
                        </button>
                        <button v-show="checkedFoodGroupList != ''" class="btn btn-danger"
                          @click="clearFilterFoodGroups()">
                          <i class="fa fa-remove"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <span>{{ $ml.get('filters.filterDeleted') }}</span>
                      <span class="form-control checkbox">
                        <label style="margin-left:20px;">
                          <input :checked="filters.isActive"
                            @change="filters.isActive == true ? filters.isActive = false : filters.isActive = true"
                            type="checkbox" />
                          {{ $ml.get('filters.filterNotShow') }}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="callout callout-info" style="margin-top:10px;">
                <div class="row">
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField1($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField1key == 0" value>{{ $ml.get('filters.filterSelectExtraFields') }}
                      </option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField1key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField1value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField2($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField2key == 0" value>{{ $ml.get('filters.filterSelectExtraFields') }}
                      </option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField2key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField2value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField3($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField3key == 0" value>{{ $ml.get('filters.filterSelectExtraFields') }}
                      </option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField3key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField3value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <select @change="changeFilterExtraField4($event)" class="form-control input-sm"
                      style="margin-bottom:5px;">
                      <option :selected="filters.extraField4key == 0" value>{{ $ml.get('filters.filterSelectExtraFields') }}
                      </option>
                      <option v-for="extraField in extraFieldList" :key="extraField.id" :value="extraField.id"
                        :selected="extraField.id == filters.extraField4key">{{ extraField.name }}</option>
                    </select>
                  </div>
                  <div class="col-md-3 col-xs-6">
                    <input v-model="filters.extraField4value" type="text" class="form-control input-sm"
                      :placeholder="$ml.get('filters.filterValue')" style="margin-bottom:5px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              <i class="fa fa-remove"></i>
              <span>{{ $ml.get('filters.filterCancel') }}</span>
            </button>
            <button @click="filtersClear()" class="btn btn-warning">
              <i class="fa fa-trash-o"></i>
              <span>{{ $ml.get('filters.filterClear') }}</span>
            </button>
            <button @click="setFilter()" class="btn btn-success" data-dismiss="modal">
              <i class="fa fa-check"></i>
              <span>{{ $ml.get('filters.filterComplete') }}</span>
            </button>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!--DEPARTMAN SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-department" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterDepartments') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <a @click="isCheckDeps == true ? getCheckDepartmentAll(false) : getCheckDepartmentAll(true)">
                <span v-text="isCheckDeps == true ? $ml.get('general.removeAll') : $ml.get('general.selectAll')"></span>
              </a>
              <input type="text" :placeholder="$ml.get('general.search')" v-model="searchText2" class="form-control"
                style="margin-bottom:10px;margin-top:10px;" autocomplete="false" />
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="dep in sortableDepartmentList" :key="dep.id">
                  <label style="margin-left:20px;">
                    <input :checked="dep.check"
                      @change="dep.check == true ? changeFilterDep(dep, false) : changeFilterDep(dep, true)"
                      type="checkbox" />
                    {{ dep.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="sortableDepartmentList.length == 0">
                  {{ $ml.get('employees.departmentNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" M data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DEPARTMAN SEÇ MODAL END -->
      <!--DURUM SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-state" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterState') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="state in stateList" :key="state.id">
                  <label style="margin-left:20px;">
                    <input :checked="state.isCheck"
                      @change="state.isCheck == true ? state.isCheck = false : state.isCheck = true" type="checkbox" />
                    {{ state.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="stateList.length == 0">
                  {{ $ml.get('employees.stateNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--DURUM SEÇ MODAL END -->
      <!--STATU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-status" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterStatus') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="status in statuList" :key="status.id">
                  <label style="margin-left:20px;">
                    <input :checked="status.isCheck"
                      @change="status.isCheck == true ? status.isCheck = false : status.isCheck = true" type="checkbox" />
                    {{ status.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="statuList.length == 0">
                  {{ $ml.get('employees.statusNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--STATU SEÇ MODAL END -->
      <!--GEÇİŞ GRUBU SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-access" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterAccessGroup') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="acc in accessGroupList" :key="acc.id">
                  <label style="margin-left:20px;">
                    <input :checked="acc.isCheck" @change="acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true"
                      type="checkbox" />
                    {{ acc.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="accessGroupList.length == 0">
                  {{ $ml.get('accessGroups.accessGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--GEÇİŞ GRUBU SEÇ MODAL END -->
      <!--ÇALIŞMA PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-workplan" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="work in periodWorkGroupList" :key="work.id">
                  <label style="margin-left:20px;">
                    <input :checked="work.isCheck" @change="work.isCheck == true ? work.isCheck = false : work.isCheck = true"
                      type="checkbox" />
                    {{ work.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="periodWorkGroupList.length == 0">
                  {{ $ml.get('workPlans.workPlanNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--ÇALIŞMA PLANI SEÇ MODAL END -->
      <!--YEMEK PLANI SEÇ MODAL -->
      <div class="modal modal-secondary fade" id="modal-select-diningHall" style="display: none;">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{ $ml.get('filters.filterWorkPlan') }}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div class="table-responsive" style="max-height:600px;owerflow:auto;">
                <span class="form-control checkbox" v-for="foodGroup in foodGroupList" :key="foodGroup.id">
                  <label style="margin-left:20px;">
                    <input :checked="foodGroup.isCheck"
                      @change="foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true"
                      type="checkbox" />
                    {{ foodGroup.name }}
                  </label>
                </span>
                <div class="callout callout-warning" v-show="foodGroupList.length == 0">
                  {{ $ml.get('foodGroups.foodGroupNotRecord') }}</div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-check"></i>
                {{ $ml.get('general.done') }}
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!--YEMEK PLANI SEÇ MODAL END -->
    </section>
  </div>
</template>
<script>
import myUpload from "vue-image-crop-upload";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingCompanies: false,
      searchText: "",
      searchText2: "",
      user: {
        id: null,
        name: "",
        title: "",
        mail: "",
        authId: null,
        currentCompanyId: null,
        password: "",
        password2: "",
        photo: null,
        monitorGroupId: null,
        authCompanies: [],
        visitorCardGroup: "",
        phoneNumber: "",
        isSmsSend: false,
        isActive: true
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isNewUser: true,
      isNewRealTimeMonitor: true,
      selectedRealTimeMonitorId: null,
      selectedRealTimeMonitorDevices: [],
      selectedRealTimeMonitorName: "",
      isCheckDeps: false,
      users: [],
      companies: [],
      departments: [],
      sortableDepTrees: [],
      userAuhtGroups: [],
      monitorGroups: [],
      readers: [],
      visitorGroups: [],
      foodGroups: [],
      accessGroups: [],
      extrafields: [],
      states: [],
      status: [],
      titles: [],
      workGroups: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      activeReports: [],
      isCheckDep: false,
      isCheckReports: false,
      reports: [
        //max index:35, max id:36
        {
          id: 32,
          name: this.$ml.get("reports.reports.SaleReport"),
          endPoint: "SaleReport",
          isActive: false,
          index: 31,
          module: this.$store.getters.getModules.retailSale
        },
        {
          id: 33,
          name: this.$ml.get("reports.reports.DetailedVisitorReport"),
          endPoint: "VisitorDetailedReport",
          isActive: false,
          index: 30,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 34,
          name: this.$ml.get("reports.reports.DepartmentBasedVisitorReport"),
          endPoint: "DepartmentBasedVisitorReport",
          isActive: false,
          index: 33,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 31,
          name: this.$ml.get("reports.reports.EntryExitSnapshotReport"),
          endPoint: "EntryExitSnapshotReport",
          isActive: false,
          index: 32,
          module: true
        },
        {
          id: 1,
          name: this.$ml.get("reports.reports.LaterComersReport"),
          endPoint: "LaterComersReport",
          isActive: false,
          index: 2,
          module: true
        },
        {
          id: 2,
          name: this.$ml.get("reports.reports.DetailedInOutReport"),
          endPoint: "DetailedInOutReport",
          isActive: false,
          index: 8,
          module: true
        },
        {
          id: 3,
          name: this.$ml.get("reports.reports.FoodReport"),
          endPoint: "FoodReport",
          isActive: false,
          index: 22,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 4,
          name: this.$ml.get("reports.reports.FoodDebtReport"),
          endPoint: "FoodDebtReport",
          isActive: false,
          index: 23,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 5,
          name: this.$ml.get("reports.reports.EmployeesReport"),
          endPoint: "EmployeesReport",
          isActive: false,
          index: 0,
          module: true
        },
        {
          id: 6,
          name: this.$ml.get("reports.reports.InsidesReport"),
          endPoint: "InsidesReport",
          isActive: false,
          index: 4,
          module: true
        },
        {
          id: 7,
          name: this.$ml.get("reports.reports.OutsidesReport"),
          endPoint: "OutsidesReport",
          isActive: false,
          index: 5,
          module: true
        },
        {
          id: 8,
          name: this.$ml.get("reports.reports.VisitorsReport"),
          endPoint: "VisitorsReport",
          isActive: false,
          index: 20,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 9,
          name: this.$ml.get("reports.reports.InsideVisitorsReport"),
          endPoint: "InsideVisitorsReport",
          isActive: false,
          index: 21,
          module: this.$store.getters.getModules.visitor
        },
        {
          id: 10,
          name: this.$ml.get("reports.reports.TimeBasedWorkReport"),
          endPoint: "TimeBasedWorkReport",
          isActive: false,
          index: 10,
          module: true
        },
        {
          id: 11,
          name: this.$ml.get("reports.reports.FirstInLastOutReport"),
          endPoint: "FirstInLastOutReport",
          isActive: false,
          index: 9,
          module: true
        },
        {
          id: 12,
          name: this.$ml.get("reports.reports.AllowenceReport"),
          endPoint: "AllowenceReport",
          isActive: false,
          index: 3,
          module: true
        },
        {
          id: 13,
          name: this.$ml.get("reports.reports.WorkSummaryReport"),
          endPoint: "WorkSummaryReport",
          isActive: false,
          index: 11,
          module: true
        },
        {
          id: 14,
          name: this.$ml.get("reports.reports.CompanyEmployeesStatusReport"),
          endPoint: "CompanyEmployeesStatusReport",
          isActive: false,
          index: 12,
          module: true
        },
        {
          id: 15,
          name: this.$ml.get(
            "reports.reports.CustomCompanyEmployeesStatusReport"
          ),
          endPoint: "CustomCompanyEmployeesStatusReport",
          isActive: false,
          index: 13,
          module: true
        },
        {
          id: 16,
          name: this.$ml.get("reports.reports.PayrollReport"),
          endPoint: "PayrollReport",
          isActive: false,
          index: 14,
          module: true
        },
        {
          id: 17,
          name: this.$ml.get("reports.reports.DetailedPayrollReport"),
          endPoint: "DetailedPayrollReport",
          isActive: false,
          index: 15,
          module: true
        },
        {
          id: 29,
          name: this.$ml.get("reports.reports.WeeklyPayrollReport"),
          endPoint: "WeeklyPayrollReport",
          isActive: false,
          index: 15,
          module: true
        },
        {
          id: 26,
          name: this.$ml.get("reports.reports.TemplatePayrollReport"),
          endPoint: "TemplatePayrollReport",
          isActive: false,
          index: 16,
          module: this.$store.getters.getModules.payroll
        },
        {
          id: 27,
          name: this.$ml.get("reports.reports.TemplateMonthlyPayrollReport"),
          endPoint: "TemplateMonthlyPayrollReport",
          isActive: false,
          index: 17,
          module: this.$store.getters.getModules.payroll
        },
        {
          id: 28,
          name: this.$ml.get("reports.reports.SalaryReport"),
          endPoint: "SalaryReport",
          isActive: false,
          index: 18,
          module: this.$store.getters.getModules.payroll
        },
        {
          id: 30,
          name: this.$ml.get("reports.reports.DepartmentSummaryReport"),
          endPoint: "DepartmentSummaryReport",
          isActive: false,
          index: 19,
          module: true
        },
        {
          id: 18,
          name: this.$ml.get("reports.reports.FoodCreditReport"),
          endPoint: "FoodCreditReport",
          isActive: false,
          index: 24,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 19,
          name: this.$ml.get("reports.reports.InOutReport"),
          endPoint: "InOutReport",
          isActive: false,
          index: 7,
          module: true
        },
        {
          id: 20,
          name: this.$ml.get("reports.reports.DoorBasedLastMovementReport"),
          endPoint: "DoorBasedLastMovementReport",
          isActive: false,
          index: 6,
          module: true
        },
        {
          id: 21,
          name: this.$ml.get("reports.reports.DoorsAuthorizationReport"),
          endPoint: "DoorsAuthorizationReport",
          isActive: false,
          index: 1,
          module: true
        },
        {
          id: 22,
          name: this.$ml.get("reports.reports.DormitoryInformationReport"),
          endPoint: "DormitoryInformationReport",
          isActive: false,
          index: 26,
          module: this.$store.getters.getModules.dormitory
        },
        {
          id: 23,
          name: this.$ml.get("reports.reports.DormitoryInsidesReport"),
          endPoint: "DormitoryInsidesReport",
          isActive: false,
          index: 27,
          module: this.$store.getters.getModules.dormitory
        },
        {
          id: 24,
          name: this.$ml.get("reports.reports.DormitoryOutsidesReport"),
          endPoint: "DormitoryOutsidesReport",
          isActive: false,
          index: 28,
          module: this.$store.getters.getModules.dormitory
        },
        {
          id: 25,
          name: this.$ml.get("reports.reports.FoodSummaryReport"),
          endPoint: "FoodSummaryReport",
          isActive: false,
          index: 29,
          module: this.$store.getters.getModules.diningHall
        },
        {
          id: 35,
          name: this.$ml.get("reports.reports.ShiftReport"),
          endPoint: "ShiftReport",
          isActive: false,
          index: 34,
          module: true
        },
        {
          id: 36,
          name: this.$ml.get("reports.reports.VerticalFirstInLastOutReport"),
          endPoint: "VerticalFirstInLastOutReport",
          isActive: false,
          index: 35,
          module: true
        },
      ]
    };
  },
  components: {
    "my-upload": myUpload
  },
  computed: {
    modules() {
      return this.$store.getters.getModules;
    },
    authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    myUser() {
      return this.$store.getters.getUser;
    },
    userList() {
      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.users.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.users;
      }
    },
    companyList() {
      return this.companies;
    },
    departmentList() {
      return this.departments;
    },
    sortableDepartmentList() {
      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.sortableDepTrees.filter(item => {
          return search
            .split(" ")
            .every(v => this.turkishToUpper(item.name).includes(v));
        });
      } else {
        return this.sortableDepTrees;
      }
    },
    checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(a => {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList() {
      return this.extrafields;
    },
    foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    userAuhtGroupList() {
      return this.userAuhtGroups.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    stateList() {
      return this.states;
    },
    checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList() {
      return this.status;
    },
    checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    titleList() {
      return this.titles;
    },
    periodWorkGroupList() {
      return this.workGroups.filter(item => {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(a => {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    monitorGroupList() {
      return this.monitorGroups;
    },
    visitorGroupList() {
      return this.visitorGroups;
    },
    reportList() {
      var list = this.reports.filter(item => {
        return item.module == true;
      });
      return list.sort((a, b) => {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 0;
      });
    },
    readerList() {
      return this.readers;
    },
    activeReaderList() {
      return this.readerList.filter(item => {
        return item.isActive == true;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    },
    windowDepHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 560;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReportHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 130;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    async clearFilterDepartments() {
      this.filters.departments = [];
      await this.sortableDepartmentList.forEach(doc => {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    async clearFilterAccessGroup() {
      this.filters.accessGroup = [];
      await this.accessGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStates() {
      this.filters.stateId = [];
      await this.stateList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterStatus() {
      this.filters.statuId = [];
      await this.statuList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterWorkPlans() {
      this.filters.workGroupId = [];
      await this.periodWorkGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async clearFilterFoodGroups() {
      this.filters.foodGroup = [];
      await this.foodGroupList.forEach(doc => {
        if (doc.isCheck == true) {
          doc.isCheck = false;
        }
      });
    },
    async getCheckDepartmentList() {
      let aList = this.sortableDepartmentList;
      this.filters.departments = [];
      await aList.forEach(doc => {
        if (doc.check == true) {
          this.filters.departments.push(doc.id);
        }
      });
      let aList2 = this.accessGroupList;
      this.filters.accessGroup = [];
      await aList2.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.accessGroup.push(doc.id);
        }
      });
      let aList3 = this.periodWorkGroupList;
      this.filters.workGroupId = [];
      await aList3.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.workGroupId.push(doc.id);
        }
      });
      let aList4 = this.foodGroupList;
      this.filters.foodGroup = [];
      await aList4.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.foodGroup.push(doc.id);
        }
      });
      let aList5 = this.statuList;
      this.filters.statuId = [];
      await aList5.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.statuId.push(doc.id);
        }
      });
      let aList6 = this.stateList;
      this.filters.stateId = [];
      await aList6.forEach(doc => {
        if (doc.isCheck == true) {
          this.filters.stateId.push(doc.id);
        }
      });
    },
    async setFilter() {
      await this.getCheckDepartmentList();
    },
    filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(a => {
        a.check = false;
      });
      this.foodGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(a => {
        a.isCheck = false;
      });
      this.stateList.forEach(a => {
        a.isCheck = false;
      });
      this.statuList.forEach(a => {
        a.isCheck = false;
      });
    },
    changeUserAuthGroup(event) {
      this.user.authId = event.target.value;
    },
    changeMonitorGroup(event) {
      this.user.monitorGroupId = event.target.value;
    },
    changeVisitorGroup(event) {
      this.user.visitorCardGroup = event.target.value;
    },
    toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.user.photo = null;
    },
    async getCheckReports() {
      this.activeReports = [];
      await this.reports.forEach(doc => {
        if (doc.isActive == true) {
          this.activeReports.push(doc.id);
        }
      });
    },
    async getCheckReportAll(value) {
      this.reports.forEach(dep => {
        dep.isActive = value;
      });
      this.isCheckReports = !this.isCheckReports;
    },
    async getCheckDepAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDep = !this.isCheckDep;
    },
    async getCheckDepartmentAll(value) {
      this.sortableDepartmentList.forEach(dep => {
        dep.check = value;
      });
      this.isCheckDeps = !this.isCheckDeps;
    },
    async changeFilterDep(dep, checkValue) {
      dep.check = checkValue;
      this.sortableDepartmentList.forEach(doc => {
        if (doc.mainDepartmentId == dep.id) {
          doc.check = checkValue;
          this.changeFilterDep(doc, checkValue);
        }
      });
    },
    async getCheckReaders() {
      this.selectedRealTimeMonitorDevices = [];
      await this.readers.forEach(doc => {
        if (doc.check == true) {
          this.selectedRealTimeMonitorDevices.push(doc.readerId);
        }
      });
    },
    selectRealTimeMonitor(id, name, devices) {
      this.isNewRealTimeMonitor = false;
      this.selectedRealTimeMonitorId = id;
      this.selectedRealTimeMonitorDevices = devices;
      this.selectedRealTimeMonitorName = name;
      this.readers.forEach(device => {
        device.check = false;
      });
      if (devices) {
        devices.forEach(item => {
          this.readers.forEach(device => {
            if (item == device.readerId) {
              device.check = true;
            }
          });
        });
      }
    },
    newRealTimeMonitor() {
      this.isNewRealTimeMonitor = true;
      this.readers.forEach(device => {
        device.check = false;
      });
      this.selectedRealTimeMonitorId = null;
      this.selectedRealTimeMonitorDevices = [];
      this.selectedRealTimeMonitorName = "";
    },
    async saveRealTimeMonitor() {
      if (this.selectedRealTimeMonitorName == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAName"));
        return;
      }
      try {
        let id = this.selectedRealTimeMonitorId;
        await this.getCheckReaders();
        let name = this.selectedRealTimeMonitorName;
        let devices = this.selectedRealTimeMonitorDevices;
        if (this.isNewRealTimeMonitor == true) {
          const response = await this.$axios
            .post("/RealTimeMonitor", {
              name: name,
              devices: devices
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newRealTimeMonitor();
          this.getMonitorGroups();
        } else {
          const response = await this.$axios
            .post("/RealTimeMonitor/" + id, {
              id: id,
              name: name,
              devices: devices
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
              }
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
          this.newRealTimeMonitor();
          this.getMonitorGroups();
        }
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    deleteRealTimeMonitor() {
      try {
        let id = this.selectedRealTimeMonitorId;
        if (id != null) {
          const response = this.$axios
            .delete("/RealTimeMonitor/" + id)
            .then(response => {
              this.getMonitorGroups();
              this.newRealTimeMonitor();
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
            })
            .catch(doc => {
              if (doc.status == 401) {
                this.$store.dispatch("logout");
              } else if (doc.message == "Network Error") {
                alertify.error(this.$ml.get("errors.connectionError"));
              } else {
                alertify.error(doc.message);
              }
            });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    newUser() {
      this.isLoadingDetail = true;
      this.isNewUser = true;
      this.user.id = null;
      this.user.name = "";
      this.user.title = "";
      this.user.mail = "";
      this.user.authId = null;
      this.user.currentCompanyId = 0;
      this.user.password = "";
      this.user.password2 = "";
      this.user.photo = null;
      this.user.monitorGroupId = 0;
      this.user.authCompanies = [];
      this.user.visitorCardGroup = "";
      this.user.phoneNumber = "";
      this.user.isSmsSend = false;
      this.user.isActive = true;
      this.imageData = null;
      this.tempUrl = null;
      this.companies.forEach(doc => {
        doc.check = true;
      });
      this.activeReports = [];
      this.reports.forEach(doc => {
        doc.isActive = false;
      });
      this.filtersClear();
      this.isLoadingDetail = false;
    },
    async deleteUser() {
      try {
        this.isLoadingDetail = true;
        let id = this.user.id;
        const response = await this.$axios
          .delete("/User/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getUsers();
        this.newUser();
        alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    getCheckAuthCompanyList() {
      let aList = this.companies;
      this.user.authCompanies = [];
      aList.forEach(doc => {
        if (doc.check == true) {
          this.user.authCompanies.push(doc.id);
        }
      });
    },
    async saveUser() {
      if (this.user.name == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAUserName"));
      }
      if (this.user.mail == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAEmail"));
      }
      if (
        this.user.password == "" ||
        this.user.password == " " ||
        this.user.password == null
      ) {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAPassword"));
        return;
      }
      if (this.user.password != this.user.password2) {
        alertify.warning(this.$ml.get("alerts.passwordsDoNotMatch"));
        return;
      }
      if (!this.user.authId) {
        alertify.warning(this.$ml.get("alerts.pleaseSelectAuthorityGroup"));
        return;
      }
      this.isLoadingDetail = true;
      await this.getCheckAuthCompanyList();
      await this.getCheckReports();
      if (this.isNewUser) {
        try {
          let user2 = this.user;
          let image = this.imageData;
          const response = await this.$axios
            .post("/User", {
              name: user2.name,
              title: user2.title,
              mail: user2.mail,
              authId: parseInt(user2.authId),
              currentCompanyId: parseInt(user2.currentCompanyId),
              password: user2.password,
              monitorGroupId: parseInt(user2.monitorGroupId),
              authCompanies: user2.authCompanies,
              visitorCardGroup: user2.visitorCardGroup,
              reports: this.activeReports,
              phoneNumber: user2.phoneNumber,
              isSmsSend: user2.isSmsSend,
              isActive: user2.isActive,
              filter: this.filters
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                } else if (error.response.status == 400) {
                  alertify.warning(error.response.data.message);
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = response.data.kullaniciId;
          if (this.imageData) {
            const formData = new FormData();
            formData.append("file", image);
            if (this.imageData != null) {
              const responseImage = await this.$axios.post(
                "/User/AddUserPhoto/" + id,
                formData
              );
            }
          }
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getUsers();
          this.getUser(id);
          this.isNewUser = false;
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let user2 = this.user;
          let image = this.imageData;
          const response = await this.$axios
            .post("/User/" + user2.id, {
              name: user2.name,
              title: user2.title,
              mail: user2.mail,
              authId: parseInt(user2.authId),
              currentCompanyId: parseInt(user2.currentCompanyId),
              password: user2.password,
              monitorGroupId: parseInt(user2.monitorGroupId),
              authCompanies: user2.authCompanies,
              visitorCardGroup: user2.visitorCardGroup,
              reports: this.activeReports,
              phoneNumber: user2.phoneNumber,
              isSmsSend: user2.isSmsSend,
              isActive: user2.isActive,
              filter: this.filters
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                } else if (error.response.status == 400) {
                  alertify.warning(error.response.data.message);
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingDetail = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingDetail = false;
                  return;
                }
              }
            });
          let id = user2.id;
          if (this.myUser.id == id) {
            localStorage.setItem(
              "defaultFilters",
              JSON.stringify(this.filters)
            );
            this.$store.commit("setDefaultFilters", this.filters);
          }
          if (this.imageData) {
            const formData = new FormData();
            formData.append("file", image);
            const responseImage = await this.$axios.post(
              "/User/AddUserPhoto/" + id,
              formData
            );
          } else if (this.user.photo == null) {
            const responseImage = await this.$axios.patch(
              "/User/RemovePhoto/" + id
            );
          }
          try {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) { }
          this.getUsers();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    setUserAuthorityFilter(filter) {
      filter.accessGroup
        ? (this.filters.accessGroup = filter.accessGroup)
        : (this.filters.accessGroup = []);
      filter.foodGroup
        ? (this.filters.foodGroup = filter.foodGroup)
        : (this.filters.foodGroup = []);
      filter.workGroupId
        ? (this.filters.workGroupId = filter.workGroupId)
        : (this.filters.workGroupId = []);
      filter.stateId
        ? (this.filters.stateId = filter.stateId)
        : (this.filters.stateId = []);
      filter.statuId
        ? (this.filters.statuId = filter.statuId)
        : (this.filters.statuId = []);
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(doc => {
        this.filters.departments.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(doc => {
        this.filters.workGroupId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(doc => {
        this.filters.accessGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(doc => {
        this.filters.foodGroup.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(doc => {
        this.filters.stateId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(doc => {
        this.filters.statuId.forEach(doc2 => {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    async getUser(id) {
      try {
        this.isLoadingDetail = true;
        this.newUser();
        const response = await this.$axios
          .get("/User/" + id)
          .then(response => {
            this.isNewUser = false;
            this.user.id = id;
            this.user.name = response.data.name;
            this.user.title = response.data.title;
            this.user.mail = response.data.mail;
            this.user.authId = response.data.authId;
            this.user.currentCompanyId = response.data.currentCompanyId;
            this.user.password = response.data.password;
            this.user.password2 = response.data.password;
            this.user.monitorGroupId = response.data.monitorGroupId;
            this.user.authCompanies = response.data.authCompanies;
            this.user.visitorCardGroup = response.data.visitorCardGroup;
            this.user.phoneNumber = response.data.phoneNumber;
            this.user.isSmsSend = response.data.isSmsSend;
            this.user.isActive = response.data.isActive;
            this.activeReports = response.data.reports;
            this.user.photo = response.data.photo;
            this.companies.forEach(doc => {
              this.user.authCompanies.forEach(doc2 => {
                if (doc.id == doc2) {
                  doc.check = true;
                }
              });
            });
            this.reports.forEach(doc => {
              this.activeReports.forEach(rep => {
                if (doc.id == rep) {
                  doc.isActive = true;
                }
              });
            });
            if (response.data.filter) {
              this.setUserAuthorityFilter(response.data.filter);
            } else {
              this.filtersClear();
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getUsers() {
      try {
        this.isLoading = true;
        const users = [];
        const response = await this.$axios
          .get("/User")
          .then(response => {
            response.data.forEach(doc => {
              users.push({
                id: doc.id,
                name: doc.name,
                title: doc.title
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.users = users;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getCompanies() {
      try {
        this.isLoadingCompanies = true;
        const companies = [];
        const response = await this.$axios
          .get("/CompanySettings")
          .then(response => {
            response.data.forEach(doc => {
              companies.push({
                id: doc.id,
                name: doc.name,
                check: true,
                logo: doc.logo,
                website: doc.website,
                phoneNumber: doc.phoneNumber,
                address: doc.address,
                title: doc.title
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.companies = companies;
        this.isLoadingCompanies = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingCompanies = false;
      }
    },
    async getDepartments() {
      try {
        this.isLoadingDetail = true;
        const departments = [];
        const response = await this.$axios
          .get("/Department")
          .then(response => {
            response.data.forEach(doc => {
              departments.push({
                id: doc.id,
                name: doc.name,
                mainDepartmentId: doc.mainDepartmentId,
                isActive: doc.isActive,
                locationTree: doc.locationTree,
                check: false
              });
              departments.sort((a, b) => {
                if (a.locationTree < b.locationTree) return -1;
                if (a.locationTree > b.locationTree) return 0;
              });
            });
            this.departments = departments;
            this.sortableTrees();
            this.isLoadingDetail = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    sortableTrees() {
      this.sortableDepTrees = [];
      this.departments.forEach(dep => {
        if (dep.mainDepartmentId == null) {
          this.sortableDepTrees.push(dep);
          this.subDepImport(dep);
        }
      });
    },
    subDepImport(dep) {
      let subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        let ek = subDep[0].locationTree.split("/");
        for (let index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(doc2 => {
          this.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          this.subDepImport(doc2);
        });
      }
    },
    async getUserAuthGroups() {
      try {
        this.isLoadingDetail = true;
        const userAuhtGroups = [];
        const response = await this.$axios
          .get("/User/UserAuthGroups")
          .then(response => {
            response.data.forEach(doc => {
              userAuhtGroups.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.userAuhtGroups = userAuhtGroups;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getMonitorGroups() {
      try {
        this.isLoadingDetail = true;
        const monitorGroups = [];
        const response = await this.$axios
          .get("/RealTimeMonitor")
          .then(response => {
            response.data.forEach(doc => {
              monitorGroups.push({
                id: doc.id,
                name: doc.name,
                devices: doc.readers
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.monitorGroups = monitorGroups;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getReaders() {
      try {
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            if (response.status == 200) {
              response.data.forEach(doc => {
                if (
                  doc.doorType == 0 ||
                  doc.doorType == 1 ||
                  doc.doorType == 2 ||
                  doc.doorType == 3 ||
                  doc.doorType == 5
                ) {
                  readers.push({
                    readerNo: doc.readerNo,
                    readerId: doc.readerId,
                    terminalId: doc.terminalId,
                    terminalNo: doc.terminalNo,
                    ipAddress: doc.ipAddress,
                    isActive: doc.isActive,
                    doorType: doc.doorType,
                    name: doc.name,
                    check: false
                  });
                }
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
              if (error.response.status == 500) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.readers = readers;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error.message);
      }
    },
    async getVisitorGroups() {
      try {
        this.isLoadingDetail = true;
        const visitorGroups = [];
        const response = await this.$axios
          .get("/Visitors/GetVisitorsCardGroup?companyId=0")
          .then(response => {
            response.data.forEach(doc => {
              visitorGroups.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingDetail = false;
                return;
              } else {
                r;
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.visitorGroups = visitorGroups;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoadingDetail = false;
      }
    },
    async getFoodGroups() {
      try {
        const foodGroups = [];
        const response = await this.$axios
          .get("/FoodGroups")
          .then(response => {
            response.data.forEach(doc => {
              foodGroups.push({
                id: doc.id,
                name: doc.name,
                type: doc.type,
                singleFoodEachMeal: doc.singleFoodEachMeal,
                meals: doc.meals,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.foodGroups = foodGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getExtraFields() {
      try {
        const extrafields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extrafields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extrafields = extrafields;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStatus() {
      try {
        const status = [];
        const response = await this.$axios
          .get("/Employees/getStatus")
          .then(response => {
            response.data.forEach(doc => {
              status.push({
                id: doc.id,
                name: doc.name,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.status = status;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getStates() {
      try {
        const states = [];
        const response = await this.$axios
          .get("/Employees/getStates")
          .then(response => {
            response.data.forEach(doc => {
              states.push({
                id: doc.id,
                name: doc.name,
                status: doc.status,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.states = states;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAccessGroups() {
      try {
        const accessGroups = [];
        const response = await this.$axios
          .get("/AccessGroups")
          .then(response => {
            response.data.forEach(doc => {
              accessGroups.push({
                id: doc.id,
                name: doc.name,
                isNewReaderAdd: doc.isNewReaderAdd,
                selectedReaders: doc.postReaders,
                isCheck: false
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.accessGroups = accessGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getWorkGroups() {
      try {
        const workGroups = [];
        const response = await this.$axios
          .get("/WorkGroups")
          .then(response => {
            response.data.forEach(doc => {
              workGroups.push({
                id: doc.id,
                name: doc.name,
                shortCode: doc.shortCode,
                isPeriod: doc.isPeriod,
                isCheck: false
              });
              workGroups.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 0;
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.workGroups = workGroups;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getTitles() {
      try {
        const titles = [];
        const response = await this.$axios
          .get("/Employees/getTitles")
          .then(response => {
            response.data.forEach(doc => {
              titles.push({
                name: doc
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.titles = titles;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getUsers();
    await this.getCompanies();
    await this.getDepartments();
    await this.getUserAuthGroups();
    await this.getMonitorGroups();
    await this.getReaders();
    await this.getVisitorGroups();
    await this.getFoodGroups();
    await this.getExtraFields();
    await this.getAccessGroups();
    await this.getStatus();
    await this.getStates();
    await this.getWorkGroups();
    await this.getTitles();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/users/Users.vue